import { render, staticRenderFns } from "./Schoolmanage.vue?vue&type=template&id=82f27294&scoped=true&"
import script from "./Schoolmanage.vue?vue&type=script&lang=js&"
export * from "./Schoolmanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f27294",
  null
  
)

export default component.exports